import { API } from 'aws-amplify';

interface CreateWorkflowResponse {
  id: number;
}

export async function createWorkflow(workflow: any): Promise<CreateWorkflowResponse> {
  const apiName = process.env.NEXT_PUBLIC_ACADEMICS_API_NAME!;
  const path = '/workflow/create-task';

  try {
    const response = await API.post(apiName, path, {
      body: workflow,
      headers: {
        'Content-Type': 'application/json',
      },
    });

    console.log('Amplify API response:', response); // Debug log
    return response;
  } catch (error) {
    console.error('Amplify API error:', error); // Debug log
    throw error;
  }
}
